module.exports = __webpack_public_path__ + "static/img/aBrightFutureForKids.8b68e71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/posters/aBrightFutureForKids.jpg
// module id = 5
// module chunks = 0